// PieceBuilderTopGuideOverlay - ピースビルダーのページ別 再閲覧ガイド
// 表示は共通の GuideOverlay。ここではページごとの案内対象と文言だけを持つ。

import { GuideStep, GuideOverlay } from "features/builder/elements/GuideOverlay";

// ガイド対象ページ。一覧タブ3種 + 詳細ページ2種（MINE/PUBLIC）。TRASH に詳細ページはない。
export enum PieceBuilderGuidePage {
  MINE_LIST = "mine_list",
  PUBLIC_LIST = "public_list",
  TRASH_LIST = "trash_list",
  MINE_DETAIL = "mine_detail",
  PUBLIC_DETAIL = "public_detail",
}

// ガイドが指す要素の id。対象側の JSX にこの id を付ける
export const GuideTargetId = {
  TAB_MINE: "piece-guide-tab-mine",
  TAB_PUBLIC: "piece-guide-tab-public",
  TRASH: "piece-guide-trash",
  // 一覧の1枚目のカード。一覧全体を指すとスポットライトが画面いっぱいになるため
  LIST_ITEM: "piece-guide-list-item",
  DETAIL_HEADER: "piece-guide-detail-header",
  DETAIL_BODY: "piece-guide-detail-body",
} as const;

const STEPS_BY_PAGE: Record<PieceBuilderGuidePage, GuideStep[]> = {
  [PieceBuilderGuidePage.MINE_LIST]: [
    {
      targetId: GuideTargetId.TAB_MINE,
      titleKey: "MSG_BUILDER_TOP_GUIDE_MINE_STEP1_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_MINE_STEP1_DESC",
    },
    {
      targetId: GuideTargetId.LIST_ITEM,
      titleKey: "MSG_BUILDER_TOP_GUIDE_MINE_STEP2_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_MINE_STEP2_DESC",
    },
  ],
  [PieceBuilderGuidePage.PUBLIC_LIST]: [
    {
      targetId: GuideTargetId.TAB_PUBLIC,
      titleKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP1_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP1_DESC",
    },
    {
      targetId: GuideTargetId.LIST_ITEM,
      titleKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP2_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP2_DESC",
    },
  ],
  [PieceBuilderGuidePage.TRASH_LIST]: [
    {
      targetId: GuideTargetId.TRASH,
      titleKey: "MSG_BUILDER_TOP_GUIDE_TRASH_STEP1_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_TRASH_STEP1_DESC",
    },
  ],
  [PieceBuilderGuidePage.MINE_DETAIL]: [
    {
      targetId: GuideTargetId.DETAIL_HEADER,
      titleKey: "MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP1_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP1_DESC",
    },
    {
      targetId: GuideTargetId.DETAIL_BODY,
      titleKey: "MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP2_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP2_DESC",
    },
  ],
  [PieceBuilderGuidePage.PUBLIC_DETAIL]: [
    {
      targetId: GuideTargetId.DETAIL_HEADER,
      titleKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP1_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP1_DESC",
    },
    {
      targetId: GuideTargetId.DETAIL_BODY,
      titleKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP2_TITLE",
      descKey: "MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP2_DESC",
    },
  ],
};

export const PieceBuilderTopGuideOverlay = ({
  open,
  page,
  onClose,
}: {
  open: boolean;
  page: PieceBuilderGuidePage;
  onClose: () => void;
}) => <GuideOverlay open={open} steps={STEPS_BY_PAGE[page]} onClose={onClose} />;
